import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tag = _resolveComponent("Tag")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.BaseControlTypeConst.VISIBLE))
    ? _withDirectives((_openBlock(), _createBlock(_component_Tag, {
        key: 0,
        container: _ctx.container,
        id: _ctx.getPropertyValue(_ctx.TagTypeConst.ID),
        style: _normalizeStyle(_ctx.getPropertyValue(_ctx.TagTypeConst.STYLE)),
        class: _normalizeClass(_ctx.getPropertyValue(_ctx.TagTypeConst.CLASS)),
        name: _ctx.getPropertyValue(_ctx.TagTypeConst.NAME),
        disabled: _ctx.getPropertyBooleanValue(_ctx.TagTypeConst.DISABLED),
        visible: _ctx.getPropertyBooleanValue(_ctx.TagTypeConst.VISIBLE),
        placeholder: _ctx.getPropertyValue(_ctx.TagTypeConst.PLACEHOLDER),
        value: _ctx.getPropertyValue(_ctx.TagTypeConst.VALUE),
        rounded: _ctx.getPropertyBooleanValue(_ctx.TagTypeConst.ROUNDED),
        icon: _ctx.getPropertyValue(_ctx.TagTypeConst.ICON),
        severity: _ctx.getCatalogValue(_ctx.TagTypeConst.SEVERITY),
        modelValue: _ctx.vmodel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vmodel) = $event)),
        onClick: _ctx.clicktest
      }, null, 8 /* PROPS */, ["container", "id", "style", "class", "name", "disabled", "visible", "placeholder", "value", "rounded", "icon", "severity", "modelValue", "onClick"])), [
        [_directive_tooltip, _ctx.getPropertyValue(_ctx.TagTypeConst.TOOLTIP)]
      ])
    : _createCommentVNode("v-if", true)
}